"use client"

import React, {useRef} from 'react';
import cx from "clsx";
import {BackgroundImage, Button} from "@mantine/core";
import {Noto_Sans_TC} from 'next/font/google';
import useGlobalStateStore from "@/app/(index)/use-global-state-store";
import {IArticleListForm} from "@/form/article";
import "./CustomDots.css";
import {IconChevronLeft, IconChevronRight, IconCircleArrowRightFilled} from '@tabler/icons-react';
import '@mantine/carousel/styles.css';
import {Carousel} from "@mantine/carousel";
import Autoplay from "embla-carousel-autoplay";

interface IProps {
    carouselList: IArticleListForm[];
}

const notoSansTC = Noto_Sans_TC({
    weight: ['400', '500', '700', '800'], // 指定粗細
    subsets: ['latin'],     // 指定支援的字符集
    display: 'swap',        // 字型載入行為
});

const HomeCarouselSm: React.FC<IProps> = ( { carouselList } ) => {
    const { fontSize, lang } = useGlobalStateStore();
    const autoplay = useRef(Autoplay({ delay: 5000 }));

    const loadCurrentFontSize = (s: number, m: number, l: number) => {
        if(fontSize == 0) return `text-[${s}px]`;
        else if(fontSize == 1) return `text-[${m}px]`;
        else if(fontSize == 2) return `text-[${l}px]`;
    }
    return (
        <Carousel loop
                  plugins={[autoplay.current]}
                  onMouseEnter={autoplay.current.stop}
                  onMouseLeave={autoplay.current.reset}
                  withControls={false}
                  withIndicators
                  nextControlIcon={<IconChevronRight size={30} color="white" />}
                  previousControlIcon={<IconChevronLeft size={30} color="white"/>}
        >
            {
                carouselList.map((item, index) => (
                    <Carousel.Slide>
                        <BackgroundImage key={`carousel2-${index}`}
                                         src={`${process.env.NEXT_PUBLIC_API_HOST}/image/${item.bannerMobileArhId?.arhId}`} className="h-[90vh]" >
                            <div className="max-w-[1250px] mx-auto relative">
                                <div className={cx("absolute left-[3%] leading-[24px] bg-black bg-opacity-40 transition text-[0.9em] max-w-[600px] pb-[15px] w-[94%] py-[10px] px-[15px] top-[25vh]"
                                )}>
                                    <div className={cx("font-extrabold mt-[10px] text-[20px] leading-[21px] mb-[10px] text-white", notoSansTC.className)}>
                                        {lang == "tw" ? item.titleC : item.titleE}
                                    </div>
                                    <div className={cx("text-[#dad9d9] text-[15px] font-medium line-clamp-2", notoSansTC.className)}>
                                        {item.summary}
                                    </div>
                                    <div className="pt-3">
                                        <Button color={"#a75943"}
                                                component={"a"}
                                                href={item.category == "LINK" ? ( lang == "tw" ? item.linkUrl!! : item.linkUrlE!! ) : `/news/detail/${item.artId}`}
                                                target={item.category == "LINK" ? '_blank' : '_parent'}
                                                rightSection={<IconCircleArrowRightFilled size={18}/>} py={3} radius={2}>{lang == "tw" ? "了解更多" : "More"}</Button>
                                    </div>
                                </div>
                            </div>
                        </BackgroundImage>
                    </Carousel.Slide>
                ))
            }
        </Carousel>
    );
}

export default HomeCarouselSm;